import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link
} from "react-router-dom";
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import { observable } from 'mobx';
import { sessionService } from '../../services/SessionService';

interface IndexRoleProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}
@observer export default class IndexRole extends React.Component<IndexRoleProps> {

    @observable private roles: any;
    @observable private isLoaded = false;

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        http.get('/api/role/read').then((response) => {
            this.roles = response.data.response;
            this.isLoaded = true;
        }).catch((error) => {
            toast.error("Error cargando roles");
        });
    }

    render() {
        if (!this.isLoaded) {
            return null;
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-primary">
                                <h4 className="card-title ">Lista de roles</h4>
                                <p className="card-category">Lista de roles de usuarios</p>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        {sessionService.canViewSection("Roles.add") &&
                                            <Link to={`/roles/nuevo`}>
                                                <button className="btn btn-info btn-lg  pull-right">
                                                    <i className="material-icons">account_circle</i> Nuevo Rol
                                                <div className="ripple-container"></div>
                                                </button>
                                            </Link>
                                        }
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead className=" text-primary">
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Permisos</th>
                                                <th className="text-right">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.roles.map((rol: any, index: any) => {
                                                    return (
                                                        <Fragment key={index}>
                                                            <tr>
                                                                <td>{rol.name}</td>
                                                                <td>{rol.claims.map((claim: any) => {
                                                                    if (claim.indexOf('.') >= 0) {
                                                                        return ``;
                                                                    }
                                                                    return `${claim}, `;
                                                                })}</td>
                                                                <td className="td-actions text-right">
                                                                    {sessionService.canViewSection("Roles.edit") &&
                                                                        <Link to={`roles/${rol.id}`}>
                                                                            <button style={{ margin: 5 }} type="button" className="btn btn-success">
                                                                                <i className="material-icons">edit</i>
                                                                            </button>
                                                                        </Link>
                                                                    }
                                                                    {rol.id !== "1" && sessionService.canViewSection("Roles.delete") &&
                                                                        <button onClick={() => this.deleteRol(rol.id, index)} style={{ margin: 5 }} type="button" className="btn btn-danger" >
                                                                            <i className="material-icons">close</i>
                                                                        </button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        </Fragment>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }

    private deleteRol = (id: any, index: any): void => {
        swal({
            title: "Confirmar acción",
            text: "¿Estas seguro que quieres borrar el rol?",
            icon: "warning",
            dangerMode: true,
        })
            .then(willDelete => {
                if (willDelete) {
                    const deleteObject = JSON.stringify({
                        id
                    });
                    http.post(`/api/role/delete`, deleteObject)
                        .then((response) => {
                            this.roles.splice(index, 1);
                            toast.success("Rol borrado correctamente");
                        }).catch((error) => {
                            if (error.includes("foreign")) {
                                toast.error("Error al borrar: Registros ligados a este rol");
                            } else {
                                toast.error("Error borrando rol");
                            }
                        })
                }
            });
    }
}